import { render, staticRenderFns } from "./OrderSignin.vue?vue&type=template&id=5766b9b2&scoped=true"
import script from "./OrderSignin.vue?vue&type=script&lang=js"
export * from "./OrderSignin.vue?vue&type=script&lang=js"
import style0 from "./OrderSignin.vue?vue&type=style&index=0&id=5766b9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5766b9b2",
  null
  
)

export default component.exports